import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from './actions'
import { useParams, Link } from 'react-router-dom'
import { InitialState } from './types'
import moment from 'moment'
import { CourseType } from '../CoursePage/types'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import LoadingPage from '../../components/LoadingPage'
import Loading from '../../components/Loading'

export default () => {
  const isMounted = useRef<boolean>(false)

  const dispatch = useDispatch()
  const { id } = useParams<{ id: string }>()

  const { user, stat, isProcessFetching, isProcessFetchingStat, error } =
    useSelector((state: { adminUserView: InitialState }) => state.adminUserView)

  useEffect(() => {
    dispatch(actions.destroy())
    dispatch(actions.fetchUser(id))
    dispatch(actions.fetchUserStat(id))
    isMounted.current = true
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  const dateDifferent = (fromDate?: string, toDate?: string): string => {
    if (!fromDate || !toDate) return ''
    const a = moment(toDate)
    const b = moment(fromDate)
    const days = a.diff(b, 'days')
    b.add(days, 'days')
    const hours = a.diff(b, 'hours')
    b.add(hours, 'hours')
    const minutes = a.diff(b, 'minutes')
    b.add(minutes, 'minutes')
    const seconds = a.diff(b, 'seconds')
    return `${days} Дней ${hours} Часов ${minutes} Минут ${seconds} Секунд`
  }

  const ItemCourse = ({ course }: { course: CourseType }): JSX.Element => {
    const content = (start?: string, endDate?: string): JSX.Element => {
      return (
        <span style={{ fontSize: 14, color: 'grey' }}>
          {` (${moment(start).format('DD.MM.YYYY HH:mm ')}-${
            endDate ? moment(endDate).format(' DD.MM.YYYY HH:mm | ') : ' ...'
          }${dateDifferent(start, endDate || '')})`}
        </span>
      )
    }

    return (
      <li key={course.course_id}>
        <Link to={`/admin/courses/${course.course_id}`}>{course.title}</Link>
        {content(
          course.user_course?.created_at,
          course.user_course?.finished_at || ''
        )}
        {course.modules?.length ? (
          <ul>
            {course.modules
              .filter(module => module.user_module)
              .map(module => (
                <li key={module.module_id}>
                  <Link
                    to={`/admin/courses/${course.course_id}/modules/${module.module_id}`}
                  >
                    {module.title}
                  </Link>
                  {content(
                    module.user_module?.created_at,
                    module.user_module?.finished_at || ''
                  )}

                  {module.lessons?.length ? (
                    <ul>
                      {module.lessons
                        .filter(lesson => lesson.user_lesson)
                        .map(lesson => (
                          <li key={lesson.module_lesson_id}>
                            <Link
                              to={`/admin/courses/${course.course_id}/lessons/${lesson.lesson_id}`}
                            >
                              {lesson.title}
                            </Link>
                            {content(
                              lesson.user_lesson?.created_at,
                              lesson.user_lesson?.finished_at || ''
                            )}
                          </li>
                        ))}
                    </ul>
                  ) : null}
                </li>
              ))}
          </ul>
        ) : null}
      </li>
    )
  }

  return (
    <>
      <Header />
      <div className={'container'}>
        {!isMounted.current || isProcessFetching || !user ? (
          <LoadingPage />
        ) : (
          <>
            <h2>Панель администрирования - Просмотр пользователя</h2>
            <table style={{ width: '100%', marginBottom: 40 }}>
              <thead>
                <tr>
                  <td style={{ width: 270 }}>
                    <b>#</b>
                  </td>
                  <td />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>ФИО</td>
                  <td>
                    {user.profile.first_name || ''}{' '}
                    {user.profile.middle_name || ''} {user.profile.last_name}
                  </td>
                </tr>
                <tr>
                  <td>Аватарка</td>
                  <td>
                    {user.raw_external_profile?.avatar_url ? (
                      <img
                        src={user.raw_external_profile.avatar_url}
                        style={{ width: 200 }}
                      />
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td>Код профиля</td>
                  <td>{user.raw_external_profile?.short_id}</td>
                </tr>
                <tr>
                  <td>Email учетной записи</td>
                  <td>{user.raw_external_profile?.email}</td>
                </tr>
                <tr>
                  <td>Контактный email</td>
                  <td>{user.profile.contact_email}</td>
                </tr>
                <tr>
                  <td>Контактный телефон</td>
                  <td>{user.profile.contact_phone}</td>
                </tr>
                <tr>
                  <td>Дата рождения</td>
                  <td>
                    {user.raw_external_profile?.birthdate
                      ? moment(user.raw_external_profile.birthdate).format(
                          'DD-MM-YYYY'
                        )
                      : null}
                  </td>
                </tr>
                <tr>
                  <td>Создан</td>
                  <td>
                    {user.profile.created_at
                      ? moment(user.profile.created_at).format('LLL')
                      : null}
                  </td>
                </tr>
                <tr>
                  <td>Обновлен</td>
                  <td>
                    {user.profile.updated_at
                      ? moment(user.profile.updated_at).format('LLL')
                      : null}
                  </td>
                </tr>
                <tr>
                  <td>Страна</td>
                  <td>Россия</td>
                </tr>
                <tr>
                  <td>Регион</td>
                  <td>
                    {user.raw_external_profile?.address
                      ? user.raw_external_profile.address.region
                      : null}
                  </td>
                </tr>
                <tr>
                  <td>Населенный пункт</td>
                  <td>
                    {user.raw_external_profile?.address
                      ? user.raw_external_profile.address.location
                      : null}
                  </td>
                </tr>
                <tr>
                  <td>Школа</td>
                  <td>{user.profile.school?.value}</td>
                </tr>
                <tr>
                  <td>Класс</td>
                  <td>{user.profile.school_group}</td>
                </tr>
                <tr>
                  <td>Список агентов</td>
                  <td>
                    <ul>
                      {user.agents?.data && user.agents.data.length
                        ? user.agents.data.map((agent, index) => (
                            <li key={`agent_${index}`}>
                              {agent.agent.smallname} ({agent.type})
                            </li>
                          ))
                        : null}
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>Список рефералов</td>
                  <td>
                    <ul>
                      {user.referrals?.data && user.referrals.data?.length
                        ? user.referrals.data.map((referral, index) => (
                            <li key={`referral_${index}`}>
                              {referral.referral.smallname}
                            </li>
                          ))
                        : null}
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>
                    Список достижений пользователя (
                    {user.user_achievements?.length || 0})
                  </td>
                  <td>
                    <ul>
                      {user.user_achievements
                        ? user.user_achievements.map(achievement => (
                            <li key={achievement.achievement.achievement_id}>
                              <Link
                                to={`/admin/achievements/${achievement.achievement_id}`}
                              >
                                {achievement.achievement.caption}
                              </Link>
                              <span style={{ fontSize: 14, color: 'grey' }}>
                                {' '}
                                {achievement.created_at
                                  ? `(${moment(achievement.created_at).format(
                                      'DD.MM.YYYY HH:mm'
                                    )})`
                                  : null}
                              </span>
                            </li>
                          ))
                        : null}
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>Список курсов пользователя</td>
                  <td>
                    {isProcessFetchingStat ? (
                      <Loading color={'#1978B2'} />
                    ) : stat ? (
                      <ul>
                        {stat
                          .filter(course => course.user_course)
                          .map(course => (
                            <ItemCourse
                              key={course.course_id}
                              course={course}
                            />
                          ))}
                      </ul>
                    ) : (
                      'Данные не получены!'
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </>
        )}
        <span style={{ color: 'red' }}>{error}</span>
      </div>
      <Footer />
    </>
  )
}
